var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.039 3.582c-.6-.313-1.423-.318-2.027-.006-2.578 1.332-4.915 2.858-6.96 4.548-.274.226-.454.541-.451.902.003.36.188.671.46.894 2.029 1.66 4.368 3.187 6.9 4.508.6.313 1.423.318 2.027.006 2.578-1.332 4.915-2.858 6.96-4.548.274-.226.454-.541.451-.902-.003-.36-.188-.671-.46-.894-2.029-1.659-4.368-3.187-6.9-4.508z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.958 13.732a.75.75 0 0 0-.794-1.273l-6.108 3.813c-.544.34-1.283.529-2.056.529-.774 0-1.513-.19-2.057-.529l-6.04-3.77a.75.75 0 1 0-.794 1.273l6.04 3.77c.829.517 1.857.756 2.85.756.995 0 2.023-.24 2.852-.757l6.107-3.813z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.958 17.486a.75.75 0 1 0-.794-1.272l-5.29 3.303c-.772.482-1.806.743-2.874.743s-2.102-.26-2.875-.743l-5.222-3.26a.75.75 0 0 0-.795 1.273l5.222 3.26c1.058.66 2.381.97 3.67.97 1.289 0 2.612-.31 3.67-.971l5.288-3.303z",
    fill: "#212121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/Stack.1da8caf2950b650b0524c43df8101cbf.svg";
export { ForwardRef as ReactComponent };